// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineBold = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.5647 11.82C17.4247 12.24 18.4447 13.74 18.4447 15.7C18.4447 18.22 16.3847 20 13.4447 20H5.98469V4.4H12.9247C15.9447 4.4 17.7847 5.84 17.7847 8.36C17.7847 10.08 16.9247 11.34 15.5647 11.82ZM12.1047 6.72H8.42469V10.96H12.2047C14.2247 10.96 15.2847 10.24 15.2847 8.78C15.2847 7.32 14.2047 6.72 12.1047 6.72ZM8.42469 17.68H12.6847C14.8047 17.68 15.9047 16.82 15.9047 15.24C15.9047 13.8 14.8247 13.1 12.7647 13.1H8.42469V17.68Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineBold };
